// source: asset/task.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var asset_util_pb = require('../asset/util_pb.js');
goog.object.extend(proto, asset_util_pb);
goog.exportSymbol('proto.asset.CreateAsTaskRequest', null, global);
goog.exportSymbol('proto.asset.CreateTaskRequest', null, global);
goog.exportSymbol('proto.asset.CreateTaskScheduleRequest', null, global);
goog.exportSymbol('proto.asset.DeleteTaskScheduleRequest', null, global);
goog.exportSymbol('proto.asset.GetListTaskScheduleRequest', null, global);
goog.exportSymbol('proto.asset.GetTaskScheduleRequest', null, global);
goog.exportSymbol('proto.asset.NetworkConfig', null, global);
goog.exportSymbol('proto.asset.Recurrence', null, global);
goog.exportSymbol('proto.asset.Task', null, global);
goog.exportSymbol('proto.asset.Task.ErrorDescriptor', null, global);
goog.exportSymbol('proto.asset.TaskListResponse', null, global);
goog.exportSymbol('proto.asset.TaskRequest', null, global);
goog.exportSymbol('proto.asset.TaskResponse', null, global);
goog.exportSymbol('proto.asset.TaskSchedule', null, global);
goog.exportSymbol('proto.asset.TaskScheduleListResponse', null, global);
goog.exportSymbol('proto.asset.TaskScheduleResponse', null, global);
goog.exportSymbol('proto.asset.UpdateTaskScheduleRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.NetworkConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.asset.NetworkConfig.repeatedFields_, null);
};
goog.inherits(proto.asset.NetworkConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.NetworkConfig.displayName = 'proto.asset.NetworkConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.Task = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.Task, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.Task.displayName = 'proto.asset.Task';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.Task.ErrorDescriptor = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.Task.ErrorDescriptor, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.Task.ErrorDescriptor.displayName = 'proto.asset.Task.ErrorDescriptor';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.Recurrence = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.Recurrence, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.Recurrence.displayName = 'proto.asset.Recurrence';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.TaskSchedule = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.TaskSchedule, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.TaskSchedule.displayName = 'proto.asset.TaskSchedule';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.CreateTaskRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.CreateTaskRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.CreateTaskRequest.displayName = 'proto.asset.CreateTaskRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.TaskRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.TaskRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.TaskRequest.displayName = 'proto.asset.TaskRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.CreateAsTaskRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.CreateAsTaskRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.CreateAsTaskRequest.displayName = 'proto.asset.CreateAsTaskRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.GetListTaskScheduleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.GetListTaskScheduleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.GetListTaskScheduleRequest.displayName = 'proto.asset.GetListTaskScheduleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.GetTaskScheduleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.GetTaskScheduleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.GetTaskScheduleRequest.displayName = 'proto.asset.GetTaskScheduleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.CreateTaskScheduleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.CreateTaskScheduleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.CreateTaskScheduleRequest.displayName = 'proto.asset.CreateTaskScheduleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.UpdateTaskScheduleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.UpdateTaskScheduleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.UpdateTaskScheduleRequest.displayName = 'proto.asset.UpdateTaskScheduleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.DeleteTaskScheduleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.DeleteTaskScheduleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.DeleteTaskScheduleRequest.displayName = 'proto.asset.DeleteTaskScheduleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.TaskListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.asset.TaskListResponse.repeatedFields_, null);
};
goog.inherits(proto.asset.TaskListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.TaskListResponse.displayName = 'proto.asset.TaskListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.TaskResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.TaskResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.TaskResponse.displayName = 'proto.asset.TaskResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.TaskScheduleListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.asset.TaskScheduleListResponse.repeatedFields_, null);
};
goog.inherits(proto.asset.TaskScheduleListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.TaskScheduleListResponse.displayName = 'proto.asset.TaskScheduleListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.asset.TaskScheduleResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.asset.TaskScheduleResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.asset.TaskScheduleResponse.displayName = 'proto.asset.TaskScheduleResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.asset.NetworkConfig.repeatedFields_ = [2,3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.NetworkConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.NetworkConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.NetworkConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.NetworkConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
vSensorId: jspb.Message.getFieldWithDefault(msg, 1, ""),
queryListList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
includeListList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
excludeListList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.NetworkConfig}
 */
proto.asset.NetworkConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.NetworkConfig;
  return proto.asset.NetworkConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.NetworkConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.NetworkConfig}
 */
proto.asset.NetworkConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVSensorId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addQueryList(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addIncludeList(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addExcludeList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.NetworkConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.NetworkConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.NetworkConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.NetworkConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVSensorId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQueryListList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getIncludeListList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getExcludeListList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
};


/**
 * optional string v_sensor_id = 1;
 * @return {string}
 */
proto.asset.NetworkConfig.prototype.getVSensorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.NetworkConfig} returns this
 */
proto.asset.NetworkConfig.prototype.setVSensorId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string query_list = 2;
 * @return {!Array<string>}
 */
proto.asset.NetworkConfig.prototype.getQueryListList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.asset.NetworkConfig} returns this
 */
proto.asset.NetworkConfig.prototype.setQueryListList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.asset.NetworkConfig} returns this
 */
proto.asset.NetworkConfig.prototype.addQueryList = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.asset.NetworkConfig} returns this
 */
proto.asset.NetworkConfig.prototype.clearQueryListList = function() {
  return this.setQueryListList([]);
};


/**
 * repeated string include_list = 3;
 * @return {!Array<string>}
 */
proto.asset.NetworkConfig.prototype.getIncludeListList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.asset.NetworkConfig} returns this
 */
proto.asset.NetworkConfig.prototype.setIncludeListList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.asset.NetworkConfig} returns this
 */
proto.asset.NetworkConfig.prototype.addIncludeList = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.asset.NetworkConfig} returns this
 */
proto.asset.NetworkConfig.prototype.clearIncludeListList = function() {
  return this.setIncludeListList([]);
};


/**
 * repeated string exclude_list = 4;
 * @return {!Array<string>}
 */
proto.asset.NetworkConfig.prototype.getExcludeListList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.asset.NetworkConfig} returns this
 */
proto.asset.NetworkConfig.prototype.setExcludeListList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.asset.NetworkConfig} returns this
 */
proto.asset.NetworkConfig.prototype.addExcludeList = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.asset.NetworkConfig} returns this
 */
proto.asset.NetworkConfig.prototype.clearExcludeListList = function() {
  return this.setExcludeListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.Task.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.Task.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.Task} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.Task.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
networkId: jspb.Message.getFieldWithDefault(msg, 2, ""),
namespace: jspb.Message.getFieldWithDefault(msg, 4, ""),
method: jspb.Message.getFieldWithDefault(msg, 5, ""),
networkConfig: (f = msg.getNetworkConfig()) && proto.asset.NetworkConfig.toObject(includeInstance, f),
referenceSnapshotId: jspb.Message.getFieldWithDefault(msg, 7, ""),
status: jspb.Message.getFieldWithDefault(msg, 8, ""),
startedAt: jspb.Message.getFieldWithDefault(msg, 9, 0),
terminatedAt: jspb.Message.getFieldWithDefault(msg, 10, 0),
abortedAt: jspb.Message.getFieldWithDefault(msg, 11, 0),
createdAt: jspb.Message.getFieldWithDefault(msg, 12, 0),
errorDescriptor: (f = msg.getErrorDescriptor()) && proto.asset.Task.ErrorDescriptor.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.Task}
 */
proto.asset.Task.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.Task;
  return proto.asset.Task.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.Task} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.Task}
 */
proto.asset.Task.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetworkId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setNamespace(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMethod(value);
      break;
    case 6:
      var value = new proto.asset.NetworkConfig;
      reader.readMessage(value,proto.asset.NetworkConfig.deserializeBinaryFromReader);
      msg.setNetworkConfig(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setReferenceSnapshotId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartedAt(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTerminatedAt(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAbortedAt(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 13:
      var value = new proto.asset.Task.ErrorDescriptor;
      reader.readMessage(value,proto.asset.Task.ErrorDescriptor.deserializeBinaryFromReader);
      msg.setErrorDescriptor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.Task.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.Task.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.Task} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.Task.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNetworkId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNamespace();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMethod();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getNetworkConfig();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.asset.NetworkConfig.serializeBinaryToWriter
    );
  }
  f = message.getReferenceSnapshotId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getStartedAt();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getTerminatedAt();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getAbortedAt();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getErrorDescriptor();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.asset.Task.ErrorDescriptor.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.Task.ErrorDescriptor.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.Task.ErrorDescriptor.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.Task.ErrorDescriptor} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.Task.ErrorDescriptor.toObject = function(includeInstance, msg) {
  var f, obj = {
title: jspb.Message.getFieldWithDefault(msg, 1, ""),
detail: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.Task.ErrorDescriptor}
 */
proto.asset.Task.ErrorDescriptor.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.Task.ErrorDescriptor;
  return proto.asset.Task.ErrorDescriptor.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.Task.ErrorDescriptor} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.Task.ErrorDescriptor}
 */
proto.asset.Task.ErrorDescriptor.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDetail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.Task.ErrorDescriptor.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.Task.ErrorDescriptor.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.Task.ErrorDescriptor} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.Task.ErrorDescriptor.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDetail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.asset.Task.ErrorDescriptor.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Task.ErrorDescriptor} returns this
 */
proto.asset.Task.ErrorDescriptor.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string detail = 2;
 * @return {string}
 */
proto.asset.Task.ErrorDescriptor.prototype.getDetail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Task.ErrorDescriptor} returns this
 */
proto.asset.Task.ErrorDescriptor.prototype.setDetail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.asset.Task.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Task} returns this
 */
proto.asset.Task.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string network_id = 2;
 * @return {string}
 */
proto.asset.Task.prototype.getNetworkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Task} returns this
 */
proto.asset.Task.prototype.setNetworkId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string namespace = 4;
 * @return {string}
 */
proto.asset.Task.prototype.getNamespace = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Task} returns this
 */
proto.asset.Task.prototype.setNamespace = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string method = 5;
 * @return {string}
 */
proto.asset.Task.prototype.getMethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Task} returns this
 */
proto.asset.Task.prototype.setMethod = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional NetworkConfig network_config = 6;
 * @return {?proto.asset.NetworkConfig}
 */
proto.asset.Task.prototype.getNetworkConfig = function() {
  return /** @type{?proto.asset.NetworkConfig} */ (
    jspb.Message.getWrapperField(this, proto.asset.NetworkConfig, 6));
};


/**
 * @param {?proto.asset.NetworkConfig|undefined} value
 * @return {!proto.asset.Task} returns this
*/
proto.asset.Task.prototype.setNetworkConfig = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.Task} returns this
 */
proto.asset.Task.prototype.clearNetworkConfig = function() {
  return this.setNetworkConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.Task.prototype.hasNetworkConfig = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string reference_snapshot_id = 7;
 * @return {string}
 */
proto.asset.Task.prototype.getReferenceSnapshotId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Task} returns this
 */
proto.asset.Task.prototype.setReferenceSnapshotId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string status = 8;
 * @return {string}
 */
proto.asset.Task.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Task} returns this
 */
proto.asset.Task.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int64 started_at = 9;
 * @return {number}
 */
proto.asset.Task.prototype.getStartedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.Task} returns this
 */
proto.asset.Task.prototype.setStartedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 terminated_at = 10;
 * @return {number}
 */
proto.asset.Task.prototype.getTerminatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.Task} returns this
 */
proto.asset.Task.prototype.setTerminatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 aborted_at = 11;
 * @return {number}
 */
proto.asset.Task.prototype.getAbortedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.Task} returns this
 */
proto.asset.Task.prototype.setAbortedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 created_at = 12;
 * @return {number}
 */
proto.asset.Task.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.Task} returns this
 */
proto.asset.Task.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional ErrorDescriptor error_descriptor = 13;
 * @return {?proto.asset.Task.ErrorDescriptor}
 */
proto.asset.Task.prototype.getErrorDescriptor = function() {
  return /** @type{?proto.asset.Task.ErrorDescriptor} */ (
    jspb.Message.getWrapperField(this, proto.asset.Task.ErrorDescriptor, 13));
};


/**
 * @param {?proto.asset.Task.ErrorDescriptor|undefined} value
 * @return {!proto.asset.Task} returns this
*/
proto.asset.Task.prototype.setErrorDescriptor = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.Task} returns this
 */
proto.asset.Task.prototype.clearErrorDescriptor = function() {
  return this.setErrorDescriptor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.Task.prototype.hasErrorDescriptor = function() {
  return jspb.Message.getField(this, 13) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.Recurrence.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.Recurrence.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.Recurrence} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.Recurrence.toObject = function(includeInstance, msg) {
  var f, obj = {
frequency: jspb.Message.getFieldWithDefault(msg, 1, ""),
day: jspb.Message.getFieldWithDefault(msg, 2, 0),
weekDay: jspb.Message.getFieldWithDefault(msg, 3, ""),
hour: jspb.Message.getFieldWithDefault(msg, 4, 0),
minute: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.Recurrence}
 */
proto.asset.Recurrence.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.Recurrence;
  return proto.asset.Recurrence.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.Recurrence} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.Recurrence}
 */
proto.asset.Recurrence.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFrequency(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDay(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setWeekDay(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHour(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinute(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.Recurrence.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.Recurrence.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.Recurrence} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.Recurrence.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrequency();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDay();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getWeekDay();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getHour();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getMinute();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string frequency = 1;
 * @return {string}
 */
proto.asset.Recurrence.prototype.getFrequency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Recurrence} returns this
 */
proto.asset.Recurrence.prototype.setFrequency = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 day = 2;
 * @return {number}
 */
proto.asset.Recurrence.prototype.getDay = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.Recurrence} returns this
 */
proto.asset.Recurrence.prototype.setDay = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string week_day = 3;
 * @return {string}
 */
proto.asset.Recurrence.prototype.getWeekDay = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.Recurrence} returns this
 */
proto.asset.Recurrence.prototype.setWeekDay = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 hour = 4;
 * @return {number}
 */
proto.asset.Recurrence.prototype.getHour = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.Recurrence} returns this
 */
proto.asset.Recurrence.prototype.setHour = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 minute = 5;
 * @return {number}
 */
proto.asset.Recurrence.prototype.getMinute = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.Recurrence} returns this
 */
proto.asset.Recurrence.prototype.setMinute = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.TaskSchedule.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.TaskSchedule.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.TaskSchedule} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.TaskSchedule.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
networkId: jspb.Message.getFieldWithDefault(msg, 2, ""),
namespace: jspb.Message.getFieldWithDefault(msg, 4, ""),
method: jspb.Message.getFieldWithDefault(msg, 5, ""),
networkConfig: (f = msg.getNetworkConfig()) && proto.asset.NetworkConfig.toObject(includeInstance, f),
displayName: jspb.Message.getFieldWithDefault(msg, 7, ""),
disabled: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
oneshot: jspb.Message.getFieldWithDefault(msg, 9, 0),
recurrence: (f = msg.getRecurrence()) && proto.asset.Recurrence.toObject(includeInstance, f),
createdAt: jspb.Message.getFieldWithDefault(msg, 11, 0),
updatedAt: jspb.Message.getFieldWithDefault(msg, 12, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.TaskSchedule}
 */
proto.asset.TaskSchedule.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.TaskSchedule;
  return proto.asset.TaskSchedule.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.TaskSchedule} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.TaskSchedule}
 */
proto.asset.TaskSchedule.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetworkId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setNamespace(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMethod(value);
      break;
    case 6:
      var value = new proto.asset.NetworkConfig;
      reader.readMessage(value,proto.asset.NetworkConfig.deserializeBinaryFromReader);
      msg.setNetworkConfig(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisabled(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOneshot(value);
      break;
    case 10:
      var value = new proto.asset.Recurrence;
      reader.readMessage(value,proto.asset.Recurrence.deserializeBinaryFromReader);
      msg.setRecurrence(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.TaskSchedule.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.TaskSchedule.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.TaskSchedule} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.TaskSchedule.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNetworkId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNamespace();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMethod();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getNetworkConfig();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.asset.NetworkConfig.serializeBinaryToWriter
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getDisabled();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getOneshot();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getRecurrence();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.asset.Recurrence.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.asset.TaskSchedule.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.TaskSchedule} returns this
 */
proto.asset.TaskSchedule.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string network_id = 2;
 * @return {string}
 */
proto.asset.TaskSchedule.prototype.getNetworkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.TaskSchedule} returns this
 */
proto.asset.TaskSchedule.prototype.setNetworkId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string namespace = 4;
 * @return {string}
 */
proto.asset.TaskSchedule.prototype.getNamespace = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.TaskSchedule} returns this
 */
proto.asset.TaskSchedule.prototype.setNamespace = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string method = 5;
 * @return {string}
 */
proto.asset.TaskSchedule.prototype.getMethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.TaskSchedule} returns this
 */
proto.asset.TaskSchedule.prototype.setMethod = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional NetworkConfig network_config = 6;
 * @return {?proto.asset.NetworkConfig}
 */
proto.asset.TaskSchedule.prototype.getNetworkConfig = function() {
  return /** @type{?proto.asset.NetworkConfig} */ (
    jspb.Message.getWrapperField(this, proto.asset.NetworkConfig, 6));
};


/**
 * @param {?proto.asset.NetworkConfig|undefined} value
 * @return {!proto.asset.TaskSchedule} returns this
*/
proto.asset.TaskSchedule.prototype.setNetworkConfig = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.TaskSchedule} returns this
 */
proto.asset.TaskSchedule.prototype.clearNetworkConfig = function() {
  return this.setNetworkConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.TaskSchedule.prototype.hasNetworkConfig = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string display_name = 7;
 * @return {string}
 */
proto.asset.TaskSchedule.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.TaskSchedule} returns this
 */
proto.asset.TaskSchedule.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool disabled = 8;
 * @return {boolean}
 */
proto.asset.TaskSchedule.prototype.getDisabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.asset.TaskSchedule} returns this
 */
proto.asset.TaskSchedule.prototype.setDisabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional int64 oneshot = 9;
 * @return {number}
 */
proto.asset.TaskSchedule.prototype.getOneshot = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.TaskSchedule} returns this
 */
proto.asset.TaskSchedule.prototype.setOneshot = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional Recurrence recurrence = 10;
 * @return {?proto.asset.Recurrence}
 */
proto.asset.TaskSchedule.prototype.getRecurrence = function() {
  return /** @type{?proto.asset.Recurrence} */ (
    jspb.Message.getWrapperField(this, proto.asset.Recurrence, 10));
};


/**
 * @param {?proto.asset.Recurrence|undefined} value
 * @return {!proto.asset.TaskSchedule} returns this
*/
proto.asset.TaskSchedule.prototype.setRecurrence = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.TaskSchedule} returns this
 */
proto.asset.TaskSchedule.prototype.clearRecurrence = function() {
  return this.setRecurrence(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.TaskSchedule.prototype.hasRecurrence = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional int64 created_at = 11;
 * @return {number}
 */
proto.asset.TaskSchedule.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.TaskSchedule} returns this
 */
proto.asset.TaskSchedule.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 updated_at = 12;
 * @return {number}
 */
proto.asset.TaskSchedule.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.TaskSchedule} returns this
 */
proto.asset.TaskSchedule.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.CreateTaskRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.CreateTaskRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.CreateTaskRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.CreateTaskRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
networkId: jspb.Message.getFieldWithDefault(msg, 2, ""),
namespace: jspb.Message.getFieldWithDefault(msg, 4, ""),
method: jspb.Message.getFieldWithDefault(msg, 5, ""),
networkConfig: (f = msg.getNetworkConfig()) && proto.asset.NetworkConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.CreateTaskRequest}
 */
proto.asset.CreateTaskRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.CreateTaskRequest;
  return proto.asset.CreateTaskRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.CreateTaskRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.CreateTaskRequest}
 */
proto.asset.CreateTaskRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetworkId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setNamespace(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMethod(value);
      break;
    case 6:
      var value = new proto.asset.NetworkConfig;
      reader.readMessage(value,proto.asset.NetworkConfig.deserializeBinaryFromReader);
      msg.setNetworkConfig(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.CreateTaskRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.CreateTaskRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.CreateTaskRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.CreateTaskRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetworkId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNamespace();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMethod();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getNetworkConfig();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.asset.NetworkConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional string network_id = 2;
 * @return {string}
 */
proto.asset.CreateTaskRequest.prototype.getNetworkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.CreateTaskRequest} returns this
 */
proto.asset.CreateTaskRequest.prototype.setNetworkId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string namespace = 4;
 * @return {string}
 */
proto.asset.CreateTaskRequest.prototype.getNamespace = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.CreateTaskRequest} returns this
 */
proto.asset.CreateTaskRequest.prototype.setNamespace = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string method = 5;
 * @return {string}
 */
proto.asset.CreateTaskRequest.prototype.getMethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.CreateTaskRequest} returns this
 */
proto.asset.CreateTaskRequest.prototype.setMethod = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional NetworkConfig network_config = 6;
 * @return {?proto.asset.NetworkConfig}
 */
proto.asset.CreateTaskRequest.prototype.getNetworkConfig = function() {
  return /** @type{?proto.asset.NetworkConfig} */ (
    jspb.Message.getWrapperField(this, proto.asset.NetworkConfig, 6));
};


/**
 * @param {?proto.asset.NetworkConfig|undefined} value
 * @return {!proto.asset.CreateTaskRequest} returns this
*/
proto.asset.CreateTaskRequest.prototype.setNetworkConfig = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.CreateTaskRequest} returns this
 */
proto.asset.CreateTaskRequest.prototype.clearNetworkConfig = function() {
  return this.setNetworkConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.CreateTaskRequest.prototype.hasNetworkConfig = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.TaskRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.TaskRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.TaskRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.TaskRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
taskId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.TaskRequest}
 */
proto.asset.TaskRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.TaskRequest;
  return proto.asset.TaskRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.TaskRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.TaskRequest}
 */
proto.asset.TaskRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.TaskRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.TaskRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.TaskRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.TaskRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string task_id = 1;
 * @return {string}
 */
proto.asset.TaskRequest.prototype.getTaskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.TaskRequest} returns this
 */
proto.asset.TaskRequest.prototype.setTaskId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.CreateAsTaskRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.CreateAsTaskRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.CreateAsTaskRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.CreateAsTaskRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
networkName: jspb.Message.getFieldWithDefault(msg, 2, ""),
namespace: jspb.Message.getFieldWithDefault(msg, 4, ""),
method: jspb.Message.getFieldWithDefault(msg, 5, ""),
networkConfig: (f = msg.getNetworkConfig()) && proto.asset.NetworkConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.CreateAsTaskRequest}
 */
proto.asset.CreateAsTaskRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.CreateAsTaskRequest;
  return proto.asset.CreateAsTaskRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.CreateAsTaskRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.CreateAsTaskRequest}
 */
proto.asset.CreateAsTaskRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetworkName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setNamespace(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMethod(value);
      break;
    case 6:
      var value = new proto.asset.NetworkConfig;
      reader.readMessage(value,proto.asset.NetworkConfig.deserializeBinaryFromReader);
      msg.setNetworkConfig(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.CreateAsTaskRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.CreateAsTaskRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.CreateAsTaskRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.CreateAsTaskRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetworkName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNamespace();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMethod();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getNetworkConfig();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.asset.NetworkConfig.serializeBinaryToWriter
    );
  }
};


/**
 * optional string network_name = 2;
 * @return {string}
 */
proto.asset.CreateAsTaskRequest.prototype.getNetworkName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.CreateAsTaskRequest} returns this
 */
proto.asset.CreateAsTaskRequest.prototype.setNetworkName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string namespace = 4;
 * @return {string}
 */
proto.asset.CreateAsTaskRequest.prototype.getNamespace = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.CreateAsTaskRequest} returns this
 */
proto.asset.CreateAsTaskRequest.prototype.setNamespace = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string method = 5;
 * @return {string}
 */
proto.asset.CreateAsTaskRequest.prototype.getMethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.CreateAsTaskRequest} returns this
 */
proto.asset.CreateAsTaskRequest.prototype.setMethod = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional NetworkConfig network_config = 6;
 * @return {?proto.asset.NetworkConfig}
 */
proto.asset.CreateAsTaskRequest.prototype.getNetworkConfig = function() {
  return /** @type{?proto.asset.NetworkConfig} */ (
    jspb.Message.getWrapperField(this, proto.asset.NetworkConfig, 6));
};


/**
 * @param {?proto.asset.NetworkConfig|undefined} value
 * @return {!proto.asset.CreateAsTaskRequest} returns this
*/
proto.asset.CreateAsTaskRequest.prototype.setNetworkConfig = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.CreateAsTaskRequest} returns this
 */
proto.asset.CreateAsTaskRequest.prototype.clearNetworkConfig = function() {
  return this.setNetworkConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.CreateAsTaskRequest.prototype.hasNetworkConfig = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.GetListTaskScheduleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.GetListTaskScheduleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.GetListTaskScheduleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.GetListTaskScheduleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
networkId: jspb.Message.getFieldWithDefault(msg, 1, ""),
pagination: (f = msg.getPagination()) && asset_util_pb.RequestPagination.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.GetListTaskScheduleRequest}
 */
proto.asset.GetListTaskScheduleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.GetListTaskScheduleRequest;
  return proto.asset.GetListTaskScheduleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.GetListTaskScheduleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.GetListTaskScheduleRequest}
 */
proto.asset.GetListTaskScheduleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetworkId(value);
      break;
    case 2:
      var value = new asset_util_pb.RequestPagination;
      reader.readMessage(value,asset_util_pb.RequestPagination.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.GetListTaskScheduleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.GetListTaskScheduleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.GetListTaskScheduleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.GetListTaskScheduleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetworkId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      asset_util_pb.RequestPagination.serializeBinaryToWriter
    );
  }
};


/**
 * optional string network_id = 1;
 * @return {string}
 */
proto.asset.GetListTaskScheduleRequest.prototype.getNetworkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.GetListTaskScheduleRequest} returns this
 */
proto.asset.GetListTaskScheduleRequest.prototype.setNetworkId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional RequestPagination pagination = 2;
 * @return {?proto.asset.RequestPagination}
 */
proto.asset.GetListTaskScheduleRequest.prototype.getPagination = function() {
  return /** @type{?proto.asset.RequestPagination} */ (
    jspb.Message.getWrapperField(this, asset_util_pb.RequestPagination, 2));
};


/**
 * @param {?proto.asset.RequestPagination|undefined} value
 * @return {!proto.asset.GetListTaskScheduleRequest} returns this
*/
proto.asset.GetListTaskScheduleRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.GetListTaskScheduleRequest} returns this
 */
proto.asset.GetListTaskScheduleRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.GetListTaskScheduleRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.GetTaskScheduleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.GetTaskScheduleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.GetTaskScheduleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.GetTaskScheduleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
taskScheduleId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.GetTaskScheduleRequest}
 */
proto.asset.GetTaskScheduleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.GetTaskScheduleRequest;
  return proto.asset.GetTaskScheduleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.GetTaskScheduleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.GetTaskScheduleRequest}
 */
proto.asset.GetTaskScheduleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskScheduleId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.GetTaskScheduleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.GetTaskScheduleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.GetTaskScheduleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.GetTaskScheduleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskScheduleId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string task_schedule_id = 1;
 * @return {string}
 */
proto.asset.GetTaskScheduleRequest.prototype.getTaskScheduleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.GetTaskScheduleRequest} returns this
 */
proto.asset.GetTaskScheduleRequest.prototype.setTaskScheduleId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.CreateTaskScheduleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.CreateTaskScheduleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.CreateTaskScheduleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.CreateTaskScheduleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
networkId: jspb.Message.getFieldWithDefault(msg, 2, ""),
namespace: jspb.Message.getFieldWithDefault(msg, 4, ""),
method: jspb.Message.getFieldWithDefault(msg, 5, ""),
networkConfig: (f = msg.getNetworkConfig()) && proto.asset.NetworkConfig.toObject(includeInstance, f),
displayName: jspb.Message.getFieldWithDefault(msg, 7, ""),
disabled: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
oneshot: jspb.Message.getFieldWithDefault(msg, 9, 0),
recurrence: (f = msg.getRecurrence()) && proto.asset.Recurrence.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.CreateTaskScheduleRequest}
 */
proto.asset.CreateTaskScheduleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.CreateTaskScheduleRequest;
  return proto.asset.CreateTaskScheduleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.CreateTaskScheduleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.CreateTaskScheduleRequest}
 */
proto.asset.CreateTaskScheduleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetworkId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setNamespace(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMethod(value);
      break;
    case 6:
      var value = new proto.asset.NetworkConfig;
      reader.readMessage(value,proto.asset.NetworkConfig.deserializeBinaryFromReader);
      msg.setNetworkConfig(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisabled(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOneshot(value);
      break;
    case 10:
      var value = new proto.asset.Recurrence;
      reader.readMessage(value,proto.asset.Recurrence.deserializeBinaryFromReader);
      msg.setRecurrence(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.CreateTaskScheduleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.CreateTaskScheduleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.CreateTaskScheduleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.CreateTaskScheduleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetworkId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNamespace();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMethod();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getNetworkConfig();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.asset.NetworkConfig.serializeBinaryToWriter
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getDisabled();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getOneshot();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getRecurrence();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.asset.Recurrence.serializeBinaryToWriter
    );
  }
};


/**
 * optional string network_id = 2;
 * @return {string}
 */
proto.asset.CreateTaskScheduleRequest.prototype.getNetworkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.CreateTaskScheduleRequest} returns this
 */
proto.asset.CreateTaskScheduleRequest.prototype.setNetworkId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string namespace = 4;
 * @return {string}
 */
proto.asset.CreateTaskScheduleRequest.prototype.getNamespace = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.CreateTaskScheduleRequest} returns this
 */
proto.asset.CreateTaskScheduleRequest.prototype.setNamespace = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string method = 5;
 * @return {string}
 */
proto.asset.CreateTaskScheduleRequest.prototype.getMethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.CreateTaskScheduleRequest} returns this
 */
proto.asset.CreateTaskScheduleRequest.prototype.setMethod = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional NetworkConfig network_config = 6;
 * @return {?proto.asset.NetworkConfig}
 */
proto.asset.CreateTaskScheduleRequest.prototype.getNetworkConfig = function() {
  return /** @type{?proto.asset.NetworkConfig} */ (
    jspb.Message.getWrapperField(this, proto.asset.NetworkConfig, 6));
};


/**
 * @param {?proto.asset.NetworkConfig|undefined} value
 * @return {!proto.asset.CreateTaskScheduleRequest} returns this
*/
proto.asset.CreateTaskScheduleRequest.prototype.setNetworkConfig = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.CreateTaskScheduleRequest} returns this
 */
proto.asset.CreateTaskScheduleRequest.prototype.clearNetworkConfig = function() {
  return this.setNetworkConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.CreateTaskScheduleRequest.prototype.hasNetworkConfig = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string display_name = 7;
 * @return {string}
 */
proto.asset.CreateTaskScheduleRequest.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.CreateTaskScheduleRequest} returns this
 */
proto.asset.CreateTaskScheduleRequest.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool disabled = 8;
 * @return {boolean}
 */
proto.asset.CreateTaskScheduleRequest.prototype.getDisabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.asset.CreateTaskScheduleRequest} returns this
 */
proto.asset.CreateTaskScheduleRequest.prototype.setDisabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional int64 oneshot = 9;
 * @return {number}
 */
proto.asset.CreateTaskScheduleRequest.prototype.getOneshot = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.CreateTaskScheduleRequest} returns this
 */
proto.asset.CreateTaskScheduleRequest.prototype.setOneshot = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional Recurrence recurrence = 10;
 * @return {?proto.asset.Recurrence}
 */
proto.asset.CreateTaskScheduleRequest.prototype.getRecurrence = function() {
  return /** @type{?proto.asset.Recurrence} */ (
    jspb.Message.getWrapperField(this, proto.asset.Recurrence, 10));
};


/**
 * @param {?proto.asset.Recurrence|undefined} value
 * @return {!proto.asset.CreateTaskScheduleRequest} returns this
*/
proto.asset.CreateTaskScheduleRequest.prototype.setRecurrence = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.CreateTaskScheduleRequest} returns this
 */
proto.asset.CreateTaskScheduleRequest.prototype.clearRecurrence = function() {
  return this.setRecurrence(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.CreateTaskScheduleRequest.prototype.hasRecurrence = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.UpdateTaskScheduleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.UpdateTaskScheduleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.UpdateTaskScheduleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.UpdateTaskScheduleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
taskScheduleId: jspb.Message.getFieldWithDefault(msg, 1, ""),
networkId: jspb.Message.getFieldWithDefault(msg, 2, ""),
networkConfig: (f = msg.getNetworkConfig()) && proto.asset.NetworkConfig.toObject(includeInstance, f),
displayName: jspb.Message.getFieldWithDefault(msg, 7, ""),
disabled: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
oneshot: jspb.Message.getFieldWithDefault(msg, 9, 0),
recurrence: (f = msg.getRecurrence()) && proto.asset.Recurrence.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.UpdateTaskScheduleRequest}
 */
proto.asset.UpdateTaskScheduleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.UpdateTaskScheduleRequest;
  return proto.asset.UpdateTaskScheduleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.UpdateTaskScheduleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.UpdateTaskScheduleRequest}
 */
proto.asset.UpdateTaskScheduleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskScheduleId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetworkId(value);
      break;
    case 6:
      var value = new proto.asset.NetworkConfig;
      reader.readMessage(value,proto.asset.NetworkConfig.deserializeBinaryFromReader);
      msg.setNetworkConfig(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisabled(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOneshot(value);
      break;
    case 10:
      var value = new proto.asset.Recurrence;
      reader.readMessage(value,proto.asset.Recurrence.deserializeBinaryFromReader);
      msg.setRecurrence(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.UpdateTaskScheduleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.UpdateTaskScheduleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.UpdateTaskScheduleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.UpdateTaskScheduleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskScheduleId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNetworkId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNetworkConfig();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.asset.NetworkConfig.serializeBinaryToWriter
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getDisabled();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getOneshot();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getRecurrence();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.asset.Recurrence.serializeBinaryToWriter
    );
  }
};


/**
 * optional string task_schedule_id = 1;
 * @return {string}
 */
proto.asset.UpdateTaskScheduleRequest.prototype.getTaskScheduleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.UpdateTaskScheduleRequest} returns this
 */
proto.asset.UpdateTaskScheduleRequest.prototype.setTaskScheduleId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string network_id = 2;
 * @return {string}
 */
proto.asset.UpdateTaskScheduleRequest.prototype.getNetworkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.UpdateTaskScheduleRequest} returns this
 */
proto.asset.UpdateTaskScheduleRequest.prototype.setNetworkId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional NetworkConfig network_config = 6;
 * @return {?proto.asset.NetworkConfig}
 */
proto.asset.UpdateTaskScheduleRequest.prototype.getNetworkConfig = function() {
  return /** @type{?proto.asset.NetworkConfig} */ (
    jspb.Message.getWrapperField(this, proto.asset.NetworkConfig, 6));
};


/**
 * @param {?proto.asset.NetworkConfig|undefined} value
 * @return {!proto.asset.UpdateTaskScheduleRequest} returns this
*/
proto.asset.UpdateTaskScheduleRequest.prototype.setNetworkConfig = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.UpdateTaskScheduleRequest} returns this
 */
proto.asset.UpdateTaskScheduleRequest.prototype.clearNetworkConfig = function() {
  return this.setNetworkConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.UpdateTaskScheduleRequest.prototype.hasNetworkConfig = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string display_name = 7;
 * @return {string}
 */
proto.asset.UpdateTaskScheduleRequest.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.UpdateTaskScheduleRequest} returns this
 */
proto.asset.UpdateTaskScheduleRequest.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool disabled = 8;
 * @return {boolean}
 */
proto.asset.UpdateTaskScheduleRequest.prototype.getDisabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.asset.UpdateTaskScheduleRequest} returns this
 */
proto.asset.UpdateTaskScheduleRequest.prototype.setDisabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional int64 oneshot = 9;
 * @return {number}
 */
proto.asset.UpdateTaskScheduleRequest.prototype.getOneshot = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.asset.UpdateTaskScheduleRequest} returns this
 */
proto.asset.UpdateTaskScheduleRequest.prototype.setOneshot = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional Recurrence recurrence = 10;
 * @return {?proto.asset.Recurrence}
 */
proto.asset.UpdateTaskScheduleRequest.prototype.getRecurrence = function() {
  return /** @type{?proto.asset.Recurrence} */ (
    jspb.Message.getWrapperField(this, proto.asset.Recurrence, 10));
};


/**
 * @param {?proto.asset.Recurrence|undefined} value
 * @return {!proto.asset.UpdateTaskScheduleRequest} returns this
*/
proto.asset.UpdateTaskScheduleRequest.prototype.setRecurrence = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.UpdateTaskScheduleRequest} returns this
 */
proto.asset.UpdateTaskScheduleRequest.prototype.clearRecurrence = function() {
  return this.setRecurrence(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.UpdateTaskScheduleRequest.prototype.hasRecurrence = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.DeleteTaskScheduleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.DeleteTaskScheduleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.DeleteTaskScheduleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.DeleteTaskScheduleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
taskScheduleId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.DeleteTaskScheduleRequest}
 */
proto.asset.DeleteTaskScheduleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.DeleteTaskScheduleRequest;
  return proto.asset.DeleteTaskScheduleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.DeleteTaskScheduleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.DeleteTaskScheduleRequest}
 */
proto.asset.DeleteTaskScheduleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskScheduleId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.DeleteTaskScheduleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.DeleteTaskScheduleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.DeleteTaskScheduleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.DeleteTaskScheduleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskScheduleId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string task_schedule_id = 1;
 * @return {string}
 */
proto.asset.DeleteTaskScheduleRequest.prototype.getTaskScheduleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.asset.DeleteTaskScheduleRequest} returns this
 */
proto.asset.DeleteTaskScheduleRequest.prototype.setTaskScheduleId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.asset.TaskListResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.TaskListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.TaskListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.TaskListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.TaskListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
pagination: (f = msg.getPagination()) && asset_util_pb.ResponsePagination.toObject(includeInstance, f),
taskListList: jspb.Message.toObjectList(msg.getTaskListList(),
    proto.asset.Task.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.TaskListResponse}
 */
proto.asset.TaskListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.TaskListResponse;
  return proto.asset.TaskListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.TaskListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.TaskListResponse}
 */
proto.asset.TaskListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new asset_util_pb.ResponsePagination;
      reader.readMessage(value,asset_util_pb.ResponsePagination.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 2:
      var value = new proto.asset.Task;
      reader.readMessage(value,proto.asset.Task.deserializeBinaryFromReader);
      msg.addTaskList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.TaskListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.TaskListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.TaskListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.TaskListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      asset_util_pb.ResponsePagination.serializeBinaryToWriter
    );
  }
  f = message.getTaskListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.asset.Task.serializeBinaryToWriter
    );
  }
};


/**
 * optional ResponsePagination pagination = 1;
 * @return {?proto.asset.ResponsePagination}
 */
proto.asset.TaskListResponse.prototype.getPagination = function() {
  return /** @type{?proto.asset.ResponsePagination} */ (
    jspb.Message.getWrapperField(this, asset_util_pb.ResponsePagination, 1));
};


/**
 * @param {?proto.asset.ResponsePagination|undefined} value
 * @return {!proto.asset.TaskListResponse} returns this
*/
proto.asset.TaskListResponse.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.TaskListResponse} returns this
 */
proto.asset.TaskListResponse.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.TaskListResponse.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Task task_list = 2;
 * @return {!Array<!proto.asset.Task>}
 */
proto.asset.TaskListResponse.prototype.getTaskListList = function() {
  return /** @type{!Array<!proto.asset.Task>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.asset.Task, 2));
};


/**
 * @param {!Array<!proto.asset.Task>} value
 * @return {!proto.asset.TaskListResponse} returns this
*/
proto.asset.TaskListResponse.prototype.setTaskListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.asset.Task=} opt_value
 * @param {number=} opt_index
 * @return {!proto.asset.Task}
 */
proto.asset.TaskListResponse.prototype.addTaskList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.asset.Task, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.asset.TaskListResponse} returns this
 */
proto.asset.TaskListResponse.prototype.clearTaskListList = function() {
  return this.setTaskListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.TaskResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.TaskResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.TaskResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.TaskResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
task: (f = msg.getTask()) && proto.asset.Task.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.TaskResponse}
 */
proto.asset.TaskResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.TaskResponse;
  return proto.asset.TaskResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.TaskResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.TaskResponse}
 */
proto.asset.TaskResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.asset.Task;
      reader.readMessage(value,proto.asset.Task.deserializeBinaryFromReader);
      msg.setTask(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.TaskResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.TaskResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.TaskResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.TaskResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTask();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.asset.Task.serializeBinaryToWriter
    );
  }
};


/**
 * optional Task task = 1;
 * @return {?proto.asset.Task}
 */
proto.asset.TaskResponse.prototype.getTask = function() {
  return /** @type{?proto.asset.Task} */ (
    jspb.Message.getWrapperField(this, proto.asset.Task, 1));
};


/**
 * @param {?proto.asset.Task|undefined} value
 * @return {!proto.asset.TaskResponse} returns this
*/
proto.asset.TaskResponse.prototype.setTask = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.TaskResponse} returns this
 */
proto.asset.TaskResponse.prototype.clearTask = function() {
  return this.setTask(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.TaskResponse.prototype.hasTask = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.asset.TaskScheduleListResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.TaskScheduleListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.TaskScheduleListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.TaskScheduleListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.TaskScheduleListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
pagination: (f = msg.getPagination()) && asset_util_pb.ResponsePagination.toObject(includeInstance, f),
taskScheduleListList: jspb.Message.toObjectList(msg.getTaskScheduleListList(),
    proto.asset.TaskSchedule.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.TaskScheduleListResponse}
 */
proto.asset.TaskScheduleListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.TaskScheduleListResponse;
  return proto.asset.TaskScheduleListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.TaskScheduleListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.TaskScheduleListResponse}
 */
proto.asset.TaskScheduleListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new asset_util_pb.ResponsePagination;
      reader.readMessage(value,asset_util_pb.ResponsePagination.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 2:
      var value = new proto.asset.TaskSchedule;
      reader.readMessage(value,proto.asset.TaskSchedule.deserializeBinaryFromReader);
      msg.addTaskScheduleList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.TaskScheduleListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.TaskScheduleListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.TaskScheduleListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.TaskScheduleListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      asset_util_pb.ResponsePagination.serializeBinaryToWriter
    );
  }
  f = message.getTaskScheduleListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.asset.TaskSchedule.serializeBinaryToWriter
    );
  }
};


/**
 * optional ResponsePagination pagination = 1;
 * @return {?proto.asset.ResponsePagination}
 */
proto.asset.TaskScheduleListResponse.prototype.getPagination = function() {
  return /** @type{?proto.asset.ResponsePagination} */ (
    jspb.Message.getWrapperField(this, asset_util_pb.ResponsePagination, 1));
};


/**
 * @param {?proto.asset.ResponsePagination|undefined} value
 * @return {!proto.asset.TaskScheduleListResponse} returns this
*/
proto.asset.TaskScheduleListResponse.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.TaskScheduleListResponse} returns this
 */
proto.asset.TaskScheduleListResponse.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.TaskScheduleListResponse.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated TaskSchedule task_schedule_list = 2;
 * @return {!Array<!proto.asset.TaskSchedule>}
 */
proto.asset.TaskScheduleListResponse.prototype.getTaskScheduleListList = function() {
  return /** @type{!Array<!proto.asset.TaskSchedule>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.asset.TaskSchedule, 2));
};


/**
 * @param {!Array<!proto.asset.TaskSchedule>} value
 * @return {!proto.asset.TaskScheduleListResponse} returns this
*/
proto.asset.TaskScheduleListResponse.prototype.setTaskScheduleListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.asset.TaskSchedule=} opt_value
 * @param {number=} opt_index
 * @return {!proto.asset.TaskSchedule}
 */
proto.asset.TaskScheduleListResponse.prototype.addTaskScheduleList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.asset.TaskSchedule, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.asset.TaskScheduleListResponse} returns this
 */
proto.asset.TaskScheduleListResponse.prototype.clearTaskScheduleListList = function() {
  return this.setTaskScheduleListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.asset.TaskScheduleResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.asset.TaskScheduleResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.asset.TaskScheduleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.TaskScheduleResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
taskSchedule: (f = msg.getTaskSchedule()) && proto.asset.TaskSchedule.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.asset.TaskScheduleResponse}
 */
proto.asset.TaskScheduleResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.asset.TaskScheduleResponse;
  return proto.asset.TaskScheduleResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.asset.TaskScheduleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.asset.TaskScheduleResponse}
 */
proto.asset.TaskScheduleResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.asset.TaskSchedule;
      reader.readMessage(value,proto.asset.TaskSchedule.deserializeBinaryFromReader);
      msg.setTaskSchedule(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.asset.TaskScheduleResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.asset.TaskScheduleResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.asset.TaskScheduleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.asset.TaskScheduleResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaskSchedule();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.asset.TaskSchedule.serializeBinaryToWriter
    );
  }
};


/**
 * optional TaskSchedule task_schedule = 1;
 * @return {?proto.asset.TaskSchedule}
 */
proto.asset.TaskScheduleResponse.prototype.getTaskSchedule = function() {
  return /** @type{?proto.asset.TaskSchedule} */ (
    jspb.Message.getWrapperField(this, proto.asset.TaskSchedule, 1));
};


/**
 * @param {?proto.asset.TaskSchedule|undefined} value
 * @return {!proto.asset.TaskScheduleResponse} returns this
*/
proto.asset.TaskScheduleResponse.prototype.setTaskSchedule = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.asset.TaskScheduleResponse} returns this
 */
proto.asset.TaskScheduleResponse.prototype.clearTaskSchedule = function() {
  return this.setTaskSchedule(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.asset.TaskScheduleResponse.prototype.hasTaskSchedule = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto.asset);
